import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getNewsBrandList = (newsData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_NEWS_BRAND_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/news-brand/list`,
        newsData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_NEWS_BRAND_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_NEWS_BRAND_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_NEWS_BRAND_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addNewsBrand = (newsData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_NEWS_BRAND_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/news-brand/add`,
        newsData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_NEWS_BRAND_SUCCESS", payload: data });
        toast.success("News Brand Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_NEWS_BRAND_FAILED", payload: data });
        toast.error("Something Went Wrong!!");
      }
    } catch (error) {
      dispatch({
        type: "ADD_NEWS_BRAND_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const editNewsBrand = (newsData, id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_NEWS_BRAND_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.put(
        `${BASE_URL}/news-brand/update/${id}`,
        newsData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_NEWS_BRAND_SUCCESS", payload: data });
        toast.success("News Brand Updated Successfully!!");
        return data;
      } else {
        dispatch({ type: "EDIT_NEWS_BRAND_FAILED", payload: data });
        toast.error("Something Went Wrong!!");
      }
    } catch (error) {
      dispatch({
        type: "EDIT_NEWS_BRAND_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewNewsBrand = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_NEWS_BRAND_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(`${BASE_URL}/news-brand/view/${id}`, config);
      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_NEWS_BRAND_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "VIEW_NEWS_BRAND_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_NEWS_BRAND_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const deleteNewsBrand = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "DELETE_NEWS_BRAND_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.delete(`${BASE_URL}/news-brand/remove/${id}`, config);
      if (data.statusCode === 200) {
        dispatch({ type: "DELETE_NEWS_BRAND_SUCCESS", payload: data });
        toast.success("News Brand Deleted Successfully!!");
        return data;
      } else {
        dispatch({ type: "DELETE_NEWS_BRAND_FAILED", payload: data });
        toast.error("Something Went Wrong!!");
      }
    } catch (error) {
      dispatch({
        type: "DELETE_NEWS_BRAND_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
